export const OCR_WHITELIST = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
